<template>
  <div class="app-layout">
    <AppSidebar />
    <div class="app-content-wrapper">
      <main class="main-content">
        <slot />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppSidebar from './AppSidebar.vue';
</script>

<style scoped>
.app-layout {
  display: flex;
  min-height: 100vh;
  background: var(--color-bg-gradient-secondary);
}

.app-content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 240px;
  transition: margin-left 0.3s ease;
}

.app-layout:has(.sidebar.collapsed) .app-content-wrapper {
  margin-left: 60px;
}

.main-content {
  flex: 1;
  padding: var(--spacing-lg);
  overflow-y: auto;
}
</style>

